(() => {
  const bag = document.querySelector('#Bag');
  const root = document.body.dataset.routeRoot || '/';
  let cartBusy = false;
  let cartReady = false;
  let cartCount = 0;
  let currentCurrency = document.body.dataset.currency || 'USD';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currentCurrency }).format(cents / 100);
  const cartMessage = message => { bag.querySelector('[data-cart-message]').textContent = message; };
  function setCartBusy(busy) {
    cartBusy = busy;
    bag.setAttribute('aria-busy', String(busy));
    bag.querySelectorAll('[data-line-change]').forEach(button => { button.disabled = busy; });
    bag.querySelector('[data-checkout]').disabled = busy || !cartReady || cartCount === 0;
  }
  function openDialog(dialog) {
    document.querySelectorAll('dialog[open]').forEach(open => { if (open !== dialog) open.close(); });
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('dialog-open');
  }
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open'); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function quantityButton(label, text, key, quantity) {
    const button = element('button', '', text);
    button.type = 'button';
    button.setAttribute('aria-label', label);
    button.dataset.lineChange = key;
    button.dataset.quantity = String(quantity);
    return button;
  }
  function renderCart(cart) {
    cartReady = true;
    cartCount = cart.item_count;
    currentCurrency = cart.currency || currentCurrency;
    document.querySelectorAll('[data-cart-count]').forEach(counter => { counter.textContent = cart.item_count; });
    const lines = document.createDocumentFragment();
    for (const item of cart.items) {
      const line = element('div', 'bag-line');
      const photo = element('img');
      photo.width = 90; photo.height = 112; photo.alt = item.featured_image?.alt || item.product_title;
      if (item.featured_image?.url || item.image) photo.src = item.featured_image?.url || item.image;
      else photo.hidden = true;
      line.append(photo);
      const info = element('div', 'bag-line-info');
      const title = element('h3');
      const link = element('a', '', item.product_title); link.href = item.url; title.append(link);
      info.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', '', item.variant_title));
      const controls = element('div', 'quantity-control');
      controls.append(quantityButton(`Decrease ${item.product_title} quantity`, '−', item.key, Math.max(0, item.quantity - 1)), element('span', '', item.quantity), quantityButton(`Increase ${item.product_title} quantity`, '+', item.key, item.quantity + 1));
      info.append(controls);
      const remove = quantityButton(`Remove ${item.product_title}`, 'Remove', item.key, 0); remove.className = 'remove-button'; info.append(remove);
      line.append(info, element('span', 'line-price', money(item.final_line_price)));
      lines.append(line);
    }
    bag.querySelector('[data-cart-lines]').replaceChildren(lines);
    bag.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    bag.querySelector('[data-cart-empty]').hidden = cart.item_count > 0;
    bag.querySelector('[data-cart-bottom]').hidden = cart.item_count === 0;
    bag.querySelector('[data-checkout]').disabled = cart.item_count === 0 || cartBusy;
  }
  async function requestCart(path, options) {
    const response = await fetch(root + path, { credentials: 'same-origin', ...options });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Your bag could not be updated. Please try again.');
    return data;
  }
  async function refreshCart() { const cart = await requestCart('cart.js'); renderCart(cart); return cart; }
  async function openCart() {
    openDialog(bag); cartMessage('Loading your bag…'); setCartBusy(true);
    try { await refreshCart(); cartMessage(''); setCartBusy(false); }
    catch { cartReady = false; setCartBusy(false); cartMessage('Your bag could not be loaded. Use the bag page below to continue.'); }
  }
  document.addEventListener('click', async event => {
    const productButton = event.target.closest('[data-open-product]');
    if (productButton) { const dialog = document.getElementById(productButton.dataset.openProduct); if (dialog) openDialog(dialog); return; }
    if (event.target.closest('[data-close-dialog]')) { event.target.closest('dialog').close(); return; }
    if (event.target.closest('[data-open-cart]')) { event.preventDefault(); if (!cartBusy) await openCart(); return; }
    const quantity = event.target.closest('[data-line-change]');
    if (!quantity || cartBusy) return;
    setCartBusy(true); cartMessage('Updating your bag…');
    try {
      const cart = await requestCart('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: quantity.dataset.lineChange, quantity: Number(quantity.dataset.quantity) }) });
      renderCart(cart); cartMessage(''); setCartBusy(false);
    } catch (error) {
      try { await refreshCart(); } catch { cartReady = false; }
      setCartBusy(false);
      cartMessage(error.message);
    }
  });
  document.querySelectorAll('.product-form').forEach(form => {
    form.addEventListener('change', event => {
      if (!event.target.matches('input[name="id"]')) return;
      const price = form.closest('.detail-copy')?.querySelector('.detail-price strong');
      if (price) price.textContent = event.target.dataset.price;
      form.querySelector('.form-message').textContent = '';
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('[data-add-button]');
      const label = button.querySelector('span');
      const message = form.querySelector('.form-message');
      if (button.disabled) return;
      button.disabled = true; label.textContent = 'Adding…'; message.textContent = '';
      try {
        await requestCart('cart/add.js', { method: 'POST', body: new FormData(form) });
        await openCart();
        if (cartReady) cartMessage('Added to your bag.');
        else cartMessage('Added to your bag. Open the bag page below to check it.');
      } catch (error) { message.textContent = error.message; }
      finally { button.disabled = false; label.textContent = 'Add to bag'; }
    });
  });
})();
